import { useNavigate, useLocation } from "react-router-dom";
import { useTransition } from "react"
import { Link } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

interface NavigationLinkProps {
  href: string
  children: React.ReactNode
  className?: string
  sx?: SxProps<Theme>
  onClick?: () => void
}

export function NavigationLink({ href, children, className, sx, onClick }: NavigationLinkProps) {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [isPending, startTransition] = useTransition()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    // Don't navigate if already on the same page
    if (pathname === href) return

    // Trigger loading bar immediately
    document.dispatchEvent(new CustomEvent('nav-start'))

    // Add brief delay to ensure visual feedback is seen
    setTimeout(() => {}, 50)

    // Call any additional onClick handler
    onClick?.()

    // Start the navigation transition
    startTransition(() => {
      navigate(href)
    })
  }

  return (
    <Link
      href={href}
      underline="none"
      {...(className ? { className } : {})}
      sx={[
        ...(isPending ? [{ opacity: 0.75, pointerEvents: "none" as const }] : []),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      onClick={handleClick}
    >
      {children}
    </Link>
  )
}
